
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"17","viewBox":"0 0 20 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#593289","fill-rule":"nonzero","stroke":"#FFF"}},[_c('path',{attrs:{"d":"M6 1h8a1 1 0 011 1v3h0H5V2a1 1 0 011-1z"}}),_c('path',{attrs:{"d":"M18 13H2a1 1 0 01-1-1V5a1 1 0 011-1h16a1 1 0 011 1v7a1 1 0 01-1 1z"}}),_c('path',{attrs:{"d":"M13 16H7a1 1 0 01-1-1v-5h8v5a1 1 0 01-1 1z"}})])])
          )
        }
      }
    